function formatDate(dateStr) {
    if (!dateStr) return '';
    try {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
        });
    } catch {
        return dateStr;
    }
}

function Accomplishments({ accomplishments }) {
    if (!accomplishments || accomplishments.length === 0) {
        return null;
    }

    return (
        <div className="bg-white border border-gray-300 rounded-lg p-5">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Recent Accomplishments</h2>
            <div className="grid grid-cols-2 md:grid-cols-1 gap-3">
                {accomplishments.map((item, index) => (
                    <div
                        key={index}
                        className="flex items-start gap-3 p-3 rounded-lg border border-gray-200"
                    >
                        <span className="text-2xl flex-shrink-0">{item.icon}</span>
                        <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start gap-2">
                                <p className="font-medium text-gray-800 text-sm">
                                    {item.title}
                                </p>
                                <span className="text-xs text-gray-400 flex-shrink-0">
                                    {formatDate(item.earned_at)}
                                </span>
                            </div>
                            <p className="text-xs text-gray-500 mt-0.5">
                                {item.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Accomplishments;
